import cn from "classnames"

import { TEASERS } from "@/const/teaser.constants"

import { useTeasers } from "@/hooks/useTeasers"
import { useTranslation } from "@/hooks/useTranslation"
import { Funnel } from "@/organisms/Funnel"
import { useFunnelTriage } from "."
import { getColorsByIndex } from "./helpers"

import styles from "./FunnelTriagePage.module.scss"

import type { FunnelTriagePageComponent } from "."

export const FunnelTriagePage: FunnelTriagePageComponent = (props) => {
  const { MixPanelEvent, getData = useFunnelTriage } = props
  const [[context], cards, isRuntime, contextFixable, attr] = getData()
  const { isLoading, isLowRuntimeCoverage } = attr

  const { t } = useTranslation()
  const { size, classes = {} } = props
  const teaser = TEASERS.SCM_INSTALLED.codeRepoNotConnected(t)
  const [showTeaser] = useTeasers({
    teasers: {
      dataReadiness: true,
      scmInstalled: teaser,
      kortexInstalled: teaser
    }
  })
  const className = cn(
    styles.container,
    "sticky-section-tab-template-ks",
    classes.container
  )

  return (
    <div className={className}>
      {!showTeaser && (
        <Funnel
          loading={isLoading}
          size={size}
          numbers={context.map((query, index) => {
            const value = query.data?.data || 0
            const shouldAdjustRuntime = isLowRuntimeCoverage || !isRuntime

            if (shouldAdjustRuntime && index === 1 && value > 2) {
              const allIssues = context[0].data?.data || 0
              const serveIssues = context[2].data?.data || 0

              if (value === allIssues) {
                const nextValue = Math.round((allIssues - serveIssues) / 2)

                if (nextValue >= serveIssues) return nextValue
              }
            }

            return value
          })}
          fixableNumbers={(contextFixable?.[0] || []).map(
            (query) => query.data?.data || 0
          )}
          cards={cards}
          getColorsByIndex={getColorsByIndex}
          MixPanelEvent={MixPanelEvent}
        />
      )}
    </div>
  )
}
